import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './zh-CN'

Vue.use(VueI18n)

export const messages = {
  'zh-CN': {
    '_lang': '简体中文',
    ...zhCN
  }
}

export default new VueI18n({
  locale: 'zh-CN',
  messages
})
